export default "<div class=\"row\">\n    <div class=\"columns medium-12\">\n        <div class=\"js-code\"></div>\n    </div>\n</div>\n";